// Récompense obtenue : carte animée (badge, points) affichée quelques secondes par-dessus
// l'écran. Chaque récompense reste un temps borné : le délai ne dépend que de la récompense
// affichée, jamais des rendus du parent (niveau du micro publié toutes les 100 ms, notes,
// changements d'état). Plusieurs récompenses défilent l'une après l'autre sans recommencer
// celle qui est déjà à l'écran. L'animation respecte « réduire les animations » (styles.css).

import { useEffect, useRef, useState } from 'react';
import { missionById, type Award } from '../../store/missions';

const CONFETTI = ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10'];

/** Durée d'affichage d'une récompense (ms). */
export const REWARD_DURATION_MS = 4200;

export function awardKey(a: Award): string {
  return `${a.id}-${a.tier}-${a.at}`;
}

export function RewardToast({ awards, onDone }: { awards: readonly Award[]; onDone: () => void }) {
  const [index, setIndex] = useState(0);
  const indexRef = useRef(0);
  const awardsRef = useRef(awards);
  const onDoneRef = useRef(onDone);
  awardsRef.current = awards;
  onDoneRef.current = onDone;
  const award: Award | undefined = awards[index];
  const key = award ? awardKey(award) : null;

  const next = () => {
    const i = indexRef.current + 1;
    if (i < awardsRef.current.length) {
      indexRef.current = i;
      setIndex(i);
    } else {
      onDoneRef.current();
    }
  };

  useEffect(() => {
    if (!key) return;
    const id = window.setTimeout(next, REWARD_DURATION_MS);
    return () => window.clearTimeout(id);
    // Le minuteur ne repart que lorsque la récompense affichée change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (!award) return null;
  const def = missionById(award.id);
  const discovery = award.tier === 'discovery';
  return (
    <div className="reward-toast" role="status" aria-live="assertive" key={key ?? undefined}>
      <div className="reward-confetti" aria-hidden="true">
        {CONFETTI.map((c) => (
          <span key={c} className={`confetti ${c}`} />
        ))}
      </div>
      <div className={discovery ? 'reward-card discovery' : 'reward-card'}>
        <span className="reward-icon" aria-hidden="true">
          {def.icon}
        </span>
        <div className="reward-text">
          <span className="reward-kicker">{discovery ? 'Mission découverte' : 'Mission accomplie'}</span>
          <strong>{def.badge[award.tier]}</strong>
          <span className="reward-xp">+{award.xp} XP</span>
        </div>
        <button type="button" className="btn ghost small" onClick={next} aria-label="Fermer">
          ✕
        </button>
      </div>
    </div>
  );
}
